module.exports = __webpack_public_path__ + "img/Coleman Now 24-Can Tote Cooler.aaf85d2c.jpg";